<script>
import PagamentosFilter from '@/components/recebiveis/lista_pagamentos/PagamentosFilter.vue'
import PagamentoCollapse from '@/components/recebiveis/lista_pagamentos/PagamentoCollapse.vue'
import CriarPagamentoModal from '@/components/recebiveis/lista_pagamentos/CriarPagamentoModal.vue'
import PagamentosTabs from '@/components/recebiveis/lista_pagamentos/PagamentosTabs.vue'
import SumarizacaoPagamentos from './lista_pagamentos/SumarizacaoPagamentos.vue'
import { conciliacaoClient, sessionStorageClient } from '../../libs'
import sub from 'date-fns/sub'
import format from 'date-fns/format'

const getFilterValue = (queryParamValue, filterKey) => {
  const sessionStorageValue = sessionStorageClient.getItem('pagamentosFilters')?.[filterKey]

  return queryParamValue || sessionStorageValue
}

export default {
  components: {
    PagamentosFilter,
    PagamentoCollapse,
    CriarPagamentoModal,
    PagamentosTabs,
    SumarizacaoPagamentos
  },
  props: {
    operadoraAnsId: String,
    prestadorId: String,
    status: String,
    responsavel: String,
    minDataPagamento: String,
    maxDataPagamento: String,
    sla: String,
    tabKey: String
  },
  data () {
    return {
      pagamentos: null,
      options: {
        itemsPerPage: 10,
        page: 1,
        sortBy: ['dataPagamento'],
        sortDesc: ['desc']
      },
      orderBy: { sort: 'dataPagamento', order: 'desc' },
      orderByOptions: [
        {
          description: 'Datas mais recentes',
          value: { sort: 'dataPagamento', order: 'desc' },
        },
        {
          description: 'Datas mais antigas ',
          value: { sort: 'dataPagamento', order: 'asc' },
        },
        {
          description: 'Maiores valores informado',
          value: { sort: 'valorInformado', order: 'desc' },
        },
        {
          description: 'Menores valores informado',
          value: { sort: 'valorInformado', order: 'asc' },
        },
        {
          description: 'Maiores percentuais conciliados',
          value: { sort: 'percentualConciliadoValor', order: 'desc' },
        },
        {
          description: 'Menores percentuais conciliados',
          value: { sort: 'percentualConciliadoValor', order: 'asc' },
        },
        {
          description: 'Maiores valores lib. de produção',
          value: { sort: 'valorPagoProducao', order: 'desc' },
        },
        {
          description: 'Menores valores lib. de produção',
          value: { sort: 'valorPagoProducao', order: 'asc' },
        },
        {
          description: 'Maiores valores de glosa',
          value: { sort: 'valorGlosado', order: 'desc' },
        },
        {
          description: 'Menores valores de glosa',
          value: { sort: 'valorGlosado', order: 'asc' },
        },
        {
          description: 'Maiores valores lib. de recurso',
          value: { sort: 'valorPagoRecurso', order: 'desc' },
        },
        {
          description: 'Menores valores lib. de recurso',
          value: { sort: 'valorPagoRecurso', order: 'asc' },
        },
        {
          description: 'Maiores valores de glosa mantida',
          value: { sort: 'valorGlosaMantida', order: 'desc' },
        },
        {
          description: 'Menores valores de glosa mantida',
          value: { sort: 'valorGlosaMantida', order: 'asc' },
        }
      ],
      tabs: [
        {
          label: 'Todos',
          key: null,
          query: {},
          showTradimus: true,
          showCliente: true
        },
        {
          label: 'Tradimus',
          key: 'statusTradimus',
          query: { statusIn: ['conciliacaoAutomaticaTradimus', 'conciliacaoManualTradimus', 'publicacaoPendente', 'faturamentoNaoIdentificado', 'valoresDivergentes'] },
          showTradimus: true,
          showCliente: true
        },
        {
          label: 'Pendente',
          key: 'statusPendente',
          query: { statusIn: ['conciliacaoAutomaticaCliente', 'conciliacaoManualCliente', 'conclusaoPendente'] },
          showCliente: true
        },
        {
          label: 'Concluído',
          key: 'statusConcluido',
          query: { statusIn: ['gerandoArquivos', 'concluido'] },
          showCliente: true
        },
        {
          label: 'Publicado',
          key: 'statusPublicado',
          query: { statusIn: ['conciliacaoAutomaticaCliente', 'conciliacaoManualCliente', 'conclusaoPendente', 'gerandoArquivos', 'concluido'] },
          showTradimus: true
        }
      ]
    }
  },
  computed: {
    prestadorIdFilter () {
      return getFilterValue(this.prestadorId, 'prestadorId')
    },
    operadoraAnsIdFilter () {
      return getFilterValue(this.operadoraAnsId, 'operadoraAnsId')
    },
    statusFilter () {
      return getFilterValue(this.status, 'status')
    },
    responsavelFilter () {
      return getFilterValue(this.responsavel, 'responsavel')
    },
    minDataPagamentoFilter () {
      return getFilterValue(this.minDataPagamento, 'minDataPagamento')
    },
    maxDataPagamentoFilter () {
      return getFilterValue(this.maxDataPagamento, 'maxDataPagamento')
    },
    minDataIdentificacaoFilter () {
      const sla = getFilterValue(this.sla, 'sla')

      if (sla === '3') return this.formatDaysAgo(3)
      if (sla === '5') return this.formatDaysAgo(5)
      return undefined
    },
    maxDataIdentificacaoFilter () {
      const sla = getFilterValue(this.sla, 'sla')

      if (sla === '5') return this.formatDaysAgo(4)
      if (sla === '6') return this.formatDaysAgo(6)
      return undefined
    },
    tabQuery () {
      return this.tabs.find(tab => tab.key === this.tabKey)?.query || {}
    },
    params () {
      return {
        includePrestador: true,
        includeOperadoraAns: true,
        isResponsavel: this.responsavelFilter === 'true',
        pageSize: this.options.itemsPerPage,
        pageNumber: this.options.page - 1,
        sorting: this.options.sortBy.map((sortBy, index) => `${this.options.sortDesc[index] ? '-' : ''}${sortBy}`),
        prestadorId: this.prestadorIdFilter ? Number(this.prestadorIdFilter) : undefined,
        operadoraAnsId: this.operadoraAnsIdFilter ? Number(this.operadoraAnsIdFilter) : undefined,
        status: this.statusFilter,
        minDataPagamento: this.minDataPagamentoFilter,
        maxDataPagamento: this.maxDataPagamentoFilter,
        minDataIdentificacao: this.minDataIdentificacaoFilter,
        maxDataIdentificacao: this.maxDataIdentificacaoFilter,
        includeIntegracaoSdi: true,
        ...this.tabQuery
      }
    },
    pagesNumber () {
      return Math.ceil(this.getPagamentosPage?.totalSize / this.getPagamentosPage?.pageSize) || 0
    },
    prestadores () {
      if(this.getPrestadores && this.getPrestadores?.data)
        return this.getPrestadores.data;
      else
        return []
    },
    operadoras () {
      if(this.getOperadoras && this.getOperadoras?.data)
        return this.getOperadoras.data;
      else
        return [];
    },
    isUsuarioTradimus () {
      const usuarioTradimus = sessionStorageClient.getItem('userData')?.['UsuarioTradimus']
      return usuarioTradimus
    },
    showTabs () {
      return this.tabs.filter(tab => this.isUsuarioTradimus ? tab.showTradimus : tab.showCliente)
    },
    pagamentosSumarizacaoParams () {
      return  {
        isResponsavel: this.responsavelFilter === 'true',
        prestadorId: this.prestadorIdFilter ? Number(this.prestadorIdFilter) : undefined,
        operadoraAnsId: this.operadoraAnsIdFilter ? Number(this.operadoraAnsIdFilter) : undefined,
        status: this.statusFilter,
        minDataPagamento: this.minDataPagamentoFilter,
        maxDataPagamento: this.maxDataPagamentoFilter,
        minDataIdentificacao: this.minDataIdentificacaoFilter,
        maxDataIdentificacao: this.maxDataIdentificacaoFilter,
        ...this.tabQuery
      }
    },
    pagamentosSumarizacao () {
     if(this.getPagamentosSumarizacao && this.getPagamentosSumarizacao?.data)
      return this.getPagamentosSumarizacao.data 
     else 
      return {}
    }
  },
  created() {
    const pagamentosFilters = sessionStorageClient.getItem('pagamentosFilters');

    if (pagamentosFilters) {
      this.$router.push({
        name: 'pagamentos',
        query: {
        ...pagamentosFilters
        }
      })
    } else {
      const currentDate = new Date()
      const year = currentDate.getFullYear()
      const month = String(currentDate.getMonth() + 1).padStart(2, '0')
      const lastDay =  new Date(year, currentDate.getMonth() + 1, 0).getDate().toString()

      const minDataPagamento = `${year}-${month}-01`
      const maxDataPagamento = `${year}-${month}-${lastDay}`

      sessionStorageClient.partialUpdate('pagamentosFilters', { minDataPagamento, maxDataPagamento })

      this.minDataPagamento = minDataPagamento
      this.maxDataPagamento = maxDataPagamento

      this.$router.push({
        name: 'pagamentos',
        query: {
        minDataPagamento,
        maxDataPagamento
        }
      })
    }
  },
  methods: {
    async applyFilters () {
      const pagamentosPage = await conciliacaoClient.pagamento.getPagamentosPage(this.params)
      this.pagamentos = pagamentosPage && pagamentosPage?.data? pagamentosPage.data : [];
      this.options.page = 1
    },
    applySorting (selectedOption) {
      this.options.sortBy = [selectedOption.sort]
      this.options.sortDesc = [selectedOption.order === 'desc']
    },
    formatDaysAgo (daysAgo) {
      return format(sub(new Date(), { days: daysAgo }), 'yyyy-MM-dd')
}
  },
  asyncComputed: {
    getPagamentosPage: {
      lazy: true,
      get () {
        return conciliacaoClient.pagamento.getPagamentosPage(this.params)
      }
    },
    getPrestadores: {
      get () {
        return conciliacaoClient.prestador.getPrestadoresPage({ pageSize: 100 }) || {}
      }
    },
    getOperadoras: {
      get () {
        return conciliacaoClient.operadora.getOperadorasPage({ pageSize: 100 }) || {}
      }
    },
    getPagamentosSumarizacao: {
      get () {
        return conciliacaoClient.pagamento.getPagamentosSumarizacao(this.pagamentosSumarizacaoParams)
      }
    }
  }
}
</script>

<template>
  <v-container class='px-6'>
    <v-col class='pt-1 pb-5 px-0' cols='12'>
      <h1>Pagamentos
        <span>
          <v-tooltip right>
            <template v-slot:activator="{on, attrs}">
              <v-btn
                color='primary'
                icon
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small>fa-regular fa-life-ring</v-icon>
              </v-btn>
            </template>
            <span
              class='px-3 py-1 ma-0'
              style='
              border: solid 1px #999;
              border-radius: 5px;
              background-color: #fff;'
            >
              Ajuda: Listagem de pagamentos e índice de conciliação
            </span>
          </v-tooltip>
        </span>
      </h1>
    </v-col>
    <PagamentosFilter
      :prestadores="prestadores"
      :operadoras="operadoras"
      :prestadorId="prestadorIdFilter"
      :operadoraAnsId="operadoraAnsIdFilter"
      :status="statusFilter"
      :responsavel="responsavelFilter"
      :minDataPagamento="minDataPagamentoFilter"
      :maxDataPagamento="maxDataPagamentoFilter"
      :sla="sla"
      :tabKey="tabKey"
      @applyFilters="applyFilters"
    />
    <v-col
      cols='12'
      class='py-0 px-1'
      style="display: flex; flex-direction: row; align-items: center; justify-content: space-between;"
    >
      <div>
        <label>Ordenar por</label>
        <v-select
          v-model="orderBy"
          :items="orderByOptions"
          item-value='value'
          item-text='description'
          :menu-props="{ bottom: true, offsetY: true }"
          flat
          solo
          dense
          outlined
          @change="applySorting({ ...filterData, ...orderBy }, 1)"
        />
      </div>
      <CriarPagamentoModal
        :prestadores="prestadores"
        :operadoras="operadoras"
      />
    </v-col>

    <PagamentosTabs
      :tabs="showTabs"
      :selectedTabKey="tabKey"
      :prestadorId="prestadorIdFilter"
      :operadoraAnsId="operadoraAnsIdFilter"
      :status="statusFilter"
      :responsavel="responsavelFilter"
      :minDataPagamento="minDataPagamentoFilter"
      :maxDataPagamento="maxDataPagamentoFilter"
    />

    <SumarizacaoPagamentos class='px-0 pt-3' v-if="getPagamentosPage?.data.length > 0" :pagamentosSumarizacao="pagamentosSumarizacao" />

    <v-progress-linear v-if="$asyncComputed.getPagamentosPage.updating" indeterminate />
    <div
      v-else-if="$asyncComputed.getPagamentosPage.error"
      class="text-center"
    >
      Não foi possível carregar a lista de pagamentos
    </div>
    <div
      v-else-if="getPagamentosPage?.data.length == 0"
      class="text-center"
    >
      Nenhum pagamento foi encontrado
    </div>
    <div v-else-if="$asyncComputed.getPagamentosPage.success">
      <v-expansion-panels
        v-if="getPagamentosPage"
        class='px-0 pt-3'
        focusable
      >
        <PagamentoCollapse
          v-for="(pagamento, index) in (getPagamentosPage?.data)"
          :key="index"
          :pagamento="pagamento"
          :isUsuarioTradimus="isUsuarioTradimus"
          @refreshPage="$asyncComputed.getPagamentosPage.update"
        />
      </v-expansion-panels>
      <v-pagination
        class='no-box-shadow'
        v-model="options.page"
        :length="pagesNumber"
        :total-visible="7"
      />
    </div>
  </v-container>
</template>
